import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import { Job } from "../../../../../../../models/job";
import Modal from "../../../../../../../components/Generic/Modal";
import OrderOperations from "../../../../../Moving/Operations";
import OperationsMaintenance from "../../../../../Moving/Operations/Maintenance";
import useStyles from "./styles";

type Props = {
  viewOnly?: boolean;
  agentId?: number;
};

const Order = (props: Props) => {
  const { viewOnly, agentId } = props;

  const classes = useStyles();

  const [modalOperationsMaintenanceIsOpen, setModalOperationsMaintenanceIsOpen] =
    useState<boolean>(false);

  const [orderSelected, setOrderSelected] = useState<Job>();

  const { t: translate } = useTranslation();

  const handleEdit = (id: number | string, order: Job) => {
    setOrderSelected(order);
    setModalOperationsMaintenanceIsOpen(true);
  };

  return (
    <>
      <Modal
        title={translate("order")}
        open={modalOperationsMaintenanceIsOpen}
        handleClose={() => {
          setModalOperationsMaintenanceIsOpen(false);
          setOrderSelected(undefined);
        }}
        className={classes.modal}
      >
        <OperationsMaintenance
          onCancel={() => {
            setModalOperationsMaintenanceIsOpen(false);
            setOrderSelected(undefined);
          }}
          onSave={() => {
            setModalOperationsMaintenanceIsOpen(false);
            setOrderSelected(undefined);
          }}
          className={classes.order}
          showTitle={false}
          id={orderSelected?.id}
        />
      </Modal>

      <OrderOperations
        className={classes.orderList}
        classNameContent={classes.orderContent}
        viewOnly={viewOnly}
        showTitle={false}
        handleNewRecord={() => setModalOperationsMaintenanceIsOpen(true)}
        handleEdit={handleEdit}
        customFilter={{ agentId }}
      />
    </>
  );
};

export default Order;
